import { apiDaInscricao } from "../../../servicos/axios";

export const adicionarPermissao = async (
  idLocalDeAtendimento: string | undefined,
  idUsuario: number | undefined
) => {
  if (!idLocalDeAtendimento || !idUsuario) {
    throw new Error("idLocalDeAtendimento ou idUsuario inválido");
  }

  const response = await apiDaInscricao().post(
    `/LocalDeAtendimento/${idLocalDeAtendimento}/adicionarPermissao`,
    null,
    {
      params: { idUsuario },
    }
  );
  return response.data;
};
